// Frontend logger — development'ta browser console'a yazar,
// production build'de no-op (devtools'a sızıntı engeli).
// Gelecekte remote error tracking (Sentry vb.) tek noktada eklenir.

const isDev = process.env.NODE_ENV === 'development';

/* eslint-disable no-console */
export const logger = {
  error: (...args: unknown[]): void => {
    if (isDev) console.error(...args);
  },
  warn: (...args: unknown[]): void => {
    if (isDev) console.warn(...args);
  },
  info: (...args: unknown[]): void => {
    if (isDev) console.info(...args);
  },
  debug: (...args: unknown[]): void => {
    if (isDev) console.debug(...args);
  },
};
/* eslint-enable no-console */
